"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _strings = require("../../config/strings");

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

var _MuiAlertHelper = require("./MuiAlertHelper");

var OnlineAlertHelper = /*#__PURE__*/function () {
  function OnlineAlertHelper() {
    (0, _classCallCheck2["default"])(this, OnlineAlertHelper);
  }

  (0, _createClass2["default"])(OnlineAlertHelper, null, [{
    key: "waitForOnlineWithAlert",

    /**
     *
     * @param ignoreAbly
     * @param useHiccupListener {boolean} If true, any short online moment is taken into account. If false, the connection needs be stable for a 2 seconds
     * @param title
     * @param message
     * @param severity
     * @param cancelButtonCaption {String|null} If null then getString('CANCEL') will be displayed
     * @returns {Promise<void>}
     */
    value: function () {
      var _waitForOnlineWithAlert = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(ignoreAbly, useHiccupListener, title, message) {
        var severity,
            cancelButtonCaption,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                severity = _args.length > 4 && _args[4] !== undefined ? _args[4] : _MuiAlertHelper.SEVERITIES.NORMAL;
                cancelButtonCaption = _args.length > 5 && _args[5] !== undefined ? _args[5] : null;

                if (!_DeviceInfoHelper["default"].isOnline(ignoreAbly)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var closeDialogFn = null;
                  var cancelled = false;

                  var onOnline = function onOnline() {
                    closeDialogFn();

                    if (useHiccupListener) {
                      _DeviceInfoHelper["default"].removeOnlineHiccupListener(onOnline);
                    } else {
                      _DeviceInfoHelper["default"].removeOnlineListener(onOnline);
                    }

                    if (cancelled) {
                      return;
                    }

                    resolve();
                  };

                  if (useHiccupListener) {
                    _DeviceInfoHelper["default"].addOnlineHiccupListener(onOnline);
                  } else {
                    _DeviceInfoHelper["default"].addOnlineListener(onOnline);
                  }

                  var cancelButton = {
                    label: cancelButtonCaption || (0, _strings.getString)('CANCEL'),
                    callback: function callback() {
                      cancelled = true;

                      if (useHiccupListener) {
                        _DeviceInfoHelper["default"].removeOnlineHiccupListener(onOnline);
                      } else {
                        _DeviceInfoHelper["default"].removeOnlineListener(onOnline);
                      }

                      closeDialogFn();
                      reject(new Error('user cancelled'));
                    }
                  };
                  closeDialogFn = (0, _MuiAlertHelper.showAlertWithOptions)({
                    title: title,
                    message: message,
                    showCloseButton: false,
                    buttons: [cancelButton],
                    severity: severity
                  });
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function waitForOnlineWithAlert(_x, _x2, _x3, _x4) {
        return _waitForOnlineWithAlert.apply(this, arguments);
      }

      return waitForOnlineWithAlert;
    }()
  }]);
  return OnlineAlertHelper;
}();

var _default = OnlineAlertHelper;
exports["default"] = _default;